import React from 'react'

interface EmptyDataProps {
    message: string;
    fontSize?: string;
}

export default function EmptyData({ message, fontSize = '' }: EmptyDataProps) {
    return (
        <div className="flex justify-center items-center h-64">
            <p className={`text-gray-500 ${fontSize} text-center`}>
                {message}
            </p>
        </div>
    )
}
